// Port of api/fuel/app/classes/filter/search/games/sorts/query/rating/user/rating.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.user',
	post: false,
	require: function(config, filter) { return sorted('rating.user', filter) > 0 },
	run: function(config, filter, data, query) {
		var alias = 'r'
		if (config.ownerType !== F.OWNER_USER) {
			alias = 'ru'
			query.rename('r', 'ru')
		}
		query.order(alias + '.rating_value', sortReverse('rating.user', filter), sortPriority('rating.user', filter))
		query.leftjoin(alias)
	}
}
